// TES-1881/1849 — shared Mangel-Status-Übergangskonfiguration (config-driven StatusTransitionControl).
// defect_status ∈ {open,in_progress,resolved,closed,cancelled} — KEIN 'verified' (D-CHK-015).
//
// TES-2229 (LH §L5.10, Mig 399): die Matrix spiegelt die SERVERSEITIGE Status-Maschine
// (guard_defect_status_transition). Freie Bahnen: open→in_progress, in_progress⇄resolved.
// NICHT mehr hier: `cancelled` (nur via CancelDefectDialog → rpc_cancel_defect, Pflicht-Grund)
// und `closed` (nur via VerifyDefectDialog → verify_defect, Verifikationsweg) — beide Übergänge
// würden als Plain-UPDATE vom DB-Guard abgewiesen (P0409).
import type { TransitionConfig } from "@plasser/ui";
import type { DefectStatus } from "@/types";

export const DEFECT_TRANSITIONS: TransitionConfig<DefectStatus> = {
  open: [{ to: "in_progress", label: "in_progress" }],
  in_progress: [{ to: "resolved", label: "resolved" }],
  resolved: [{ to: "in_progress", label: "in_progress" }],
  closed: [],
  cancelled: [],
};

/** TES-2042: Terminal-Stati (keine Übergänge mehr, Menü versteckt Edit) — geteiltes
 * Prädikat für das Karten-Klick-Routing (Defects.openDefect / Tasks.handleOpenDefect). */
export function isTerminalDefectStatus(status: DefectStatus): boolean {
  return status === "closed" || status === "cancelled";
}
